import { GeneratedSignerLayoutIdentity } from '../generated/domain-models/generated-signer-layout.identity';

export class SignerLayoutIdentity extends GeneratedSignerLayoutIdentity {

}
